import Vue from "vue";
import App from "./App.vue";

import HighchartsVue from "highcharts-vue";

import Button from "ant-design-vue/lib/button";
import "ant-design-vue/lib/button/style/css";
import DatePicker from "ant-design-vue/lib/date-picker";
import "ant-design-vue/lib/date-picker/style/css";
import message from "ant-design-vue/lib/message";
import "ant-design-vue/lib/message/style/css";
import Table from "ant-design-vue/lib/table";
import "ant-design-vue/lib/table/style/css";
import Input from "ant-design-vue/lib/input";
import "ant-design-vue/lib/input/style/css";
import Popconfirm from "ant-design-vue/lib/popconfirm";
import "ant-design-vue/lib/popconfirm/style/css";

Vue.prototype.$message = message;
Vue.use(HighchartsVue);
Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Table);
Vue.use(Input);
Vue.use(Popconfirm);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App)
}).$mount("#app");
